import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { calcPercent } from './util';
import Indicator from './Indicator';

type ProgressBarProps = {
  metColor: string;
  notMetColor: string;
  metDescription?: any;
  MetEndAdornment?: any;
  notMetDescription?: any;
  NotMetEndAdornment?: any;
  descriptionWidth?: any;
  title: string;
  currentPercent: number;
};

const SmallProgressBar = ({
  metColor,
  notMetColor,
  metDescription,
  notMetDescription,
  NotMetEndAdornment,
  MetEndAdornment,
  title,
  currentPercent,
  descriptionWidth = calcPercent(currentPercent, 100)
}: ProgressBarProps) => {
  const classes = useStyles();
  const mainRef: any = React.useRef(null);

  return (
    <Box display="flex" flex={1} flexDirection="column" position="relative" marginBottom={3}>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Typography variant="subtitle2" style={{ fontWeight: 450 }}>
          {title}
        </Typography>
      </Box>

      <div ref={mainRef} className={classes.notMet} style={{ backgroundColor: notMetColor }}>
        {currentPercent > 0 && <Indicator color={metColor} style={{ width: 2 }} />}
      </div>
      <Box
        className={classes.met}
        width={`${calcPercent(currentPercent, 100)}%`}
        style={{
          backgroundColor: metColor,
          ...(currentPercent === 100 && { borderTopRightRadius: 8, borderBottomRightRadius: 8 })
        }}
      />

      <Box display="flex" flex={1}>
        <Box
          style={{
            display: 'flex',
            ...(currentPercent > 0 && { borderLeft: `2px solid ${metColor}` })
          }}
        ></Box>
        {currentPercent > 0 ? (
          <Typography
            style={{
              display: 'flex',
              marginTop: `25px`,
              width: `${+descriptionWidth}%`,
              fontSize: 16,
              whiteSpace: 'nowrap'
            }}
          >
            <Typography style={{ marginLeft: 8, fontWeight: 450, fontSize: 18 }}>
              {currentPercent}%
            </Typography>

            {metDescription}
            {MetEndAdornment}
          </Typography>
        ) : (
          <Box height={50} />
        )}

        {currentPercent !== 100 && (
          <Box
            style={{
              display: 'flex',
              width: '10',
              fontSize: 16,
              marginLeft: `${+descriptionWidth}%`,
              position: 'absolute',
              // whiteSpace: 'pre',
              verticalAlign: 'center',
              borderLeft: `2px solid ${notMetColor}`
            }}
          >
            <Typography
              noWrap
              className="notMetDescription"
              style={{
                display: 'flex',
                alignItems: 'center',
                fontWeight: 450,
                fontSize: 18,
                ...(descriptionWidth > 64 && { marginLeft: `-${+descriptionWidth + 35}%` })
              }}
            >
              {100 - currentPercent}% {notMetDescription}
              {NotMetEndAdornment}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  notMet: {
    display: 'flex',
    height: 8,
    borderRadius: '8px'
  },
  met: {
    display: 'flex',
    height: 8,
    justifyContent: 'flex-end',
    borderRadius: '8px 0px 0px 8px',
    marginTop: -8
  },
  icon: {
    marginLeft: 2
  }
}));
export default SmallProgressBar;
